module.exports = __webpack_public_path__ + "img/pdf.9c67e94a.svg";